import React from 'react'




// Yes, it identifies behaviours like phone usage, fatigue, and improper posture.
// Does RoadSense work in all vehicles?
// Yes, it’s designed for non-assisted vehicles.
// What happens when an alert is triggered?
// The Control Room team communicates with the driver in real-time to resolve issues.
// Can the Control Room track driver performance?
// Yes, it monitors behaviours and provides feedback for safer driving.
// Is the Control Room service available nationwide?
// Yes, Shoora provides nationwide support for fleets and is also deployed in 10+ countries.
// Can Shoora detect road risks?
// Yes, using ADAS technology like collision detection and lane monitoring.
// Are Shoora’s solutions scalable?
// Yes, they support fleets of all sizes, from small businesses to large enterprises.
// Is fleet data secure with Shoora?
// Yes, Shoora ensures data security through encryption and cloud protection.
// How long does installation take?
// Shoora solutions are plug-and-play, ensuring quick setup within minutes in each vehicle.

const Accordion = ({data}) => {
    return (
        <>
            <div className="accordion accordion-flush" id="accordionFlushShoora">
                {
                    data?.length > 0 && data?.map((acc, key) => (
                        <div className="accordion-item" key={key}>
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed fs-4 " type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse${key}`} aria-expanded="false" aria-controls={`flush-collapse${key}`}>
                                    {acc?.question || `Question ${key}`}
                                </button>
                            </h2>
                            <div id={`flush-collapse${key}`} className="accordion-collapse collapse" data-bs-parent="#accordionFlushShoora">
                                <div className="accordion-body">{acc?.answer || `Answer ${key}`}</div>
                            </div>
                        </div>
                    )) 
                }

            </div>
        </>
    )
}

export default Accordion